import React, {memo,Fragment} from 'react'
import { Row,Col,Container} from 'react-bootstrap'
// import { Link } from 'react-router-dom'


const SubHeader = memo((props) => {


    return (
        <Fragment>
            <div className="iq-navbar-header header-banner-modern">
                <Container fluid className=" iq-container">
                    <Row>
                        <Col md="12">
                            <div className="d-flex justify-content-between flex-wrap">
                                <div>
                                    {/* <h1>Hello, Admin</h1> */}
                                    {/* <p>We are on a mission to help developers like you build successful projects for FREE.</p> */}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                {/* banner dekoratif (gradient + pola), pengganti gambar template */}
                <div className="iq-header-img" aria-hidden="true">
                    <svg className="wave" viewBox="0 0 600 70" preserveAspectRatio="none" fill="currentColor">
                        <path d="M0 40 C 100 10, 200 70, 300 40 S 500 10, 600 40 L 600 70 L 0 70 Z" />
                        <path opacity="0.6" d="M0 55 C 120 30, 220 75, 330 52 S 520 30, 600 55 L 600 70 L 0 70 Z" />
                    </svg>
                </div>
            </div>
        </Fragment>
    )
})

export default SubHeader
